<template>
  <div>
    <b-row>
      <b-col sm="3">
        <b-form-group label="CPF/CNPJ">
          <input-documento
            v-model="model.documentoFederal"
            v-mask="documentMask"
            :required="false"
          />
        </b-form-group>
      </b-col>

      <b-col sm="3">
        <b-form-group label="Nome/Razão Social">
          <b-input 
            v-model="model.nome"
            placeholder="Digite o nome ou razão social"
            maxlength="100"
          />
        </b-form-group>
      </b-col>

      <b-col sm="6">
        <b-form-group label="Data Marcação">
          <b-row>
            <b-col sm="4">
              <kendo-datepicker 
                v-model="model.dataInicial"
                :max="dtMax"
                v-mask="'##/##/####'"
                :format="'dd/MM/yyyy'"
                :required="true"
              />
            </b-col>
            <b-col sm="4">
              <kendo-datepicker 
                v-model="model.dataFinal"
                :min="dtMin"
                :max="new Date()"
                v-mask="'##/##/####'"
                :format="'dd/MM/yyyy'"
                :required="true"
              />
            </b-col>
          </b-row>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="6">
        <b-form-group label="Identificador da Transação">
          <b-input 
            v-model="model.idTransacao"
            placeholder="Digite o identificador da transação"
            maxlength="50"
          />
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { getDocumentMask } from '@/helpers/masks'

export default {
  props: {
    value: { type: Object, required: true }
  },
  computed: {
    documentMask () {
          const v = this.model.documentoFederal || null
          return getDocumentMask(v)
    },
    dtMin: function () {
      return this.model.dataInicial
        ? kendo.parseDate(this.model.dataInicial)
        : new Date('1970-01-01Z00:00:00:000')
    },
    dtMax: function () {
      return this.model.dataFinal 
        ? kendo.parseDate(this.model.dataFinal) 
        : new Date()
    },
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
}
</script>